import type { UiState } from '../reducers';

export const getUi = (state): UiState => state.ui;
export const getRegisteredOnCompanyPage = (state) =>
  state.ui.registeredOnCompanyPage;
